/*
 *
 * IwaIllustrationPage constants
 *
 */

export const CHANGE_LIFE_ASSURED_ACTION =
  'app/IwaIllustrationPage/CHANGE_LIFE_ASSURED_ACTION';
export const SET_PRODUCT_CONFIG_ACTION =
  'app/IwaIllustrationPage/SET_PRODUCT_CONFIG_ACTION';
export const SET_COVERAGES_LIST_ACTION =
  'app/IwaIllustrationPage/SET_COVERAGES_LIST_ACTION';
export const SET_IWA_CONFIG_ACTION =
  'app/IwaIllustrationPage/SET_IWA_CONFIG_ACTION';
export const GET_IWA_CONFIG_SUCCESS_ACTION =
  'app/IwaIllustrationPage/GET_IWA_CONFIG_ACTION';
export const CREATE_QUOTE_ACTION =
  'app/IwaIllustrationPage/CREATE_QUOTE_ACTION';
export const CALCULATE_QUOTE_ACTION =
  'app/IwaIllustrationPage/CALCULATE_QUOTE_ACTION';
export const SET_QUOTE_ACTION = 'app/IwaIllustrationPage/SET_QUOTE_ACTION';
export const SET_CALCULATION_ACTION =
  'app/IwaIllustrationPage/SET_CALCULATION_ACTION';
export const ADD_POLICY_OWNER_ACTION =
  'app/IwaIllustrationPage/ADD_POLICY_OWNER_ACTION';
export const GET_QUOTE_ACTION = 'app/IwaIllustrationPage/GET_QUOTE_ACTION';
export const UPDATE_STATUS_ACTION =
  'app/IwaIllustrationPage/UPDATE_STATUS_ACTION';
export const SET_QUOTE_DETAILS_ACTION =
  'app/IwaIllustrationPage/SET_QUOTE_DETAILS_ACTION';
export const SET_PTV_VERSION_ACTION =
  'app/IwaIllustrationPage/SET_PTV_VERSION_ACTION';
export const SET_APPLICATION_ID_ACTION =
  'app/IwaIllustrationPage/SET_APPLICATION_ID_ACTION';
export const EMAIL_PDF_ACTION = 'app/IwaIllustrationPage/EMAIL_PDF_ACTION';
export const CREATE_APPLICATION_ACTION =
  'app/IwaIllustrationPage/CREATE_APPLICATION_ACTION';
export const SET_ERROR_ACTION = 'app/IwaIllustrationPage/SET_ERROR_ACTION';
export const RESET_ACTION = 'app/IwaIllustrationPage/RESET_ACTION';
export const GET_FIA_ACTION = 'app/IwaIllustrationPage/GET_FIA_ACTION';
export const SET_FIA_ACTION = 'app/IwaIllustrationPage/SET_FIA_ACTION';
export const SET_BI_TABLE_VALUES_ACTION =
  'app/IwaIllustrationPage/SET_BI_TABLE_VALUES_ACTION';
export const CLONE_QUOTE_ACTION = 'app/IwaIllustrationPage/CLONE_QUOTE_ACTION';
export const SET_CLONE_STATUS_ACTION =
  'app/IwaIllustrationPage/SET_CLONE_STATUS_ACTION';
export const SET_BI_PDF_ACTION = 'app/IwaIllustrationPage/SET_BI_PDF_ACTION';
export const SET_EMAIL_SENT_ACTION =
  'app/IwaIllustrationPage/SET_EMAIL_SENT_ACTION';
export const SET_EMAIL_ERROR_MESSAGE_ACTION =
  'app/IwaIllustrationPage/SET_EMAIL_ERROR_MESSAGE_ACTION';

export const SET_PRODUCT_CODE_ACTION =
  'app/IwaIllustrationPage/SET_PRODUCT_CODE_ACTION';

export const SET_FORM_INPUT = 'app/IwaIllustrationPage/SET_FORM_INPUT';

export const PAYMENT_TERM_SINGLE_LUMP_SUMP = 'Single payment (Lump Sum)';

export const PAYMENT_TERM_MONTHLY = 'Regular payments over 12 months';

export const IWA_PRODUCT_CODE = 'IWA';
